import { get } from '../utilities/api'

export const getOffers = (params, cancelToken) => get({
  cancelToken,
  url: '/offers/search',
  params
})
